export const Items: import('../../../sim/dex-items').ModdedItemDataTable = {
	adamantorb: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	burndrive: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	chilldrive: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	custapberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	dousedrive: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	enigmaberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	griseousorb: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	jabocaberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	lustrousorb: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	micleberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	rowapberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	shockdrive: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	souldew: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
};
